import { application } from "./application"

import ExpandDataController from "./expand_data_controller"
application.register("expand-data", ExpandDataController)

import LoaderController from "./loader_controller"
application.register("loader", LoaderController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import ToggleClassController from "./toggle_class_controller"
application.register("toggle-class", ToggleClassController)
